export interface ColorPickerProps {
  colors: string[];
  selected?: string[];
  onChange: (values: string[]) => void;
}

// Mapa boja za prijevod u CSS boje
const colorMap: Record<string, string> = {
  BIJELA: "bg-white",
  CRNA: "bg-black",
  ZELENA: "bg-[#07AE66]",
  PLAVA: "bg-[#21A5FF]",
  SIVA: "bg-[#DBDBDB]",
  CRVENA: "bg-[#DA291C]",
  NARANČASTA: "bg-[#F9AC39]",
  ROZA: "bg-[#DA1CB7]",
  ŽUTA: "bg-[#FFDA45]",
  LJUBIČASTA: "bg-[#8425FF]",
  CIJAN: "bg-[#00FFFF]"
};

export function ColorPicker(props: ColorPickerProps) {
  const { colors, selected = [], onChange } = props;

  // Normaliziraj boje u lowercase
  const normalizedColors = colors.map((color) => color.toUpperCase());

  // Handler za klik na boju
  const handleColorClick = (color: string) => {
    const colorInUppercase = color.toUpperCase();
    let updatedColors: string[];

    if (selected.includes(colorInUppercase)) {
      // Ukloni boju ako je već odabrana
      updatedColors = selected.filter((c) => c !== colorInUppercase);
    } else {
      // Dodaj boju ako nije odabrana
      updatedColors = [...selected, colorInUppercase];
    }

    onChange(updatedColors); // Pošalji ažurirani niz odabranih boja
  };

  return (
    <div className="flex flex-col gap-3">
      <label className="text-sm font-medium text-filter-gray">Boja</label>
      <div className="flex flex-wrap w-full gap-2">
        {normalizedColors.map((color) => (
          <div
            key={color}
            className={`w-11 h-11 lg:w-8 lg:h-8 rounded cursor-pointer border ${
              selected.includes(color)
                ? "border-black"
                : "border-extra-light"
            } ${colorMap[color]}`}
            onClick={() => handleColorClick(color)}
          ></div>
        ))}
      </div>
    </div>
  );
}

export default ColorPicker;
